import styled from 'styled-components';
import { StatusOffer } from '../../utils';

interface SpanProps {
	$status: StatusOffer;
}

export const ImageStatusSpan = styled.span<SpanProps>`
    position: absolute;
    left: 10px;
    top: 10px;
    background: ${({ $status }) =>
		$status === StatusOffer.Soon || $status === StatusOffer.Available
			? ({ theme }) => theme.colors.neutral.green
			: ({ theme }) => theme.colors.neutral.red};
    color: #ffffff;
    padding: 6px 8px;
    border-radius: 6px;
    box-shadow: 0 0 40px 5px rgb(0 0 0 / 5%);
    text-transform: uppercase;
    font-size: 12px;
    font-weight: 500;
    letter-spacing: .5px;
    z-index: 1;
`;